import { z as e } from "zod";
const ze = e.object({
  name: e.string(),
  id: e.string(),
  email: e.string(),
  role: e.string(),
  created_at: e.date(),
  deleted_at: e.date().nullable()
}), Be = "editorTextBox", Z = e.object({
  orderId: e.string(),
  orderProductId: e.string(),
  applicationType: e.string(),
  userId: e.string(),
  funeralHomeId: e.string(),
  timestamp: e.string()
}), Ge = e.discriminatedUnion("type", [
  e.object({
    type: e.literal("EDITOR_BACK_BUTTON"),
    payload: Z
  })
]), He = e.object({
  orderId: e.string(),
  orderProductId: e.string(),
  applicationType: e.string()
}), we = e.object({
  success: e.boolean(),
  message: e.string(),
  action: e.enum(["created", "existing", "processing", "skipped", "notified"]),
  pdfId: e.string().optional()
}), ke = {
  MDL_EDITOR_EVENTS: "mdl_editor_events"
}, s = (o) => e.guid({
  // The message names a malformed id only: a missing value, or one that is
  // not a string, keeps zod's own message, which says what was received.
  error: (n) => n.code === "invalid_format" ? o : void 0
}), t = s(), Ve = e.object({
  fromDate: e.string().regex(/^\d{4}-\d{2}-\d{2}$/, {
    error: "Invalid date format. Expected format: yyyy-mm-dd"
  }).optional()
}), qe = e.object({
  pageSetId: t,
  themeId: t,
  productId: t,
  applyToTheme: t.optional(),
  funeralHomeId: t.optional()
}), Qe = e.object({
  sourceProductId: t,
  targetProductId: t,
  sourceThemeId: t.optional(),
  sourcePageSetIds: e.array(t).optional(),
  funeralHomeId: t.optional()
}).refine((o) => o.sourceProductId !== o.targetProductId, {
  path: ["targetProductId"],
  error: "Cannot copy to the same product"
}), $e = e.object({
  productName: e.string().min(1),
  foldLine: e.enum(["vertical-center", "horizontal-center", "none"]),
  numberOfPages: e.number().min(1),
  thumbnailURL: e.url(),
  widthInches: e.number().min(1),
  heightInches: e.number().min(1),
  widthPixels: e.number().min(1),
  heightPixels: e.number().min(1),
  padding: e.object({
    top: e.number().min(0),
    right: e.number().min(0),
    bottom: e.number().min(0),
    left: e.number().min(0),
    centerHorizontal: e.number().min(0),
    centerVertical: e.number().min(0)
  })
}), We = e.object({
  productId: t,
  application: e.enum(["MDL", "M3"]),
  themeId: t.optional(),
  numberOfPages: e.int().min(1).optional()
}), Ze = e.object({
  baseThemeId: t,
  newThemeName: e.string().min(1)
}), U = 16383, K = {
  prefix: "prefix",
  first: "first",
  nickname: "nickname",
  middle: "middle",
  last: "last",
  suffix: "suffix",
  maiden: "maiden"
}, N = ["M3", "MDL"], X = {
  // The AI image edits switch (Site Settings > AI Image Edits in M3) is off,
  // so no background removal or Enhance may start or be accepted.
  AI_IMAGE_EDITS_DISABLED: "AI_IMAGE_EDITS_DISABLED"
}, Y = {
  QUEUED: "QUEUED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
}, m = {
  BG_REMOVAL: "BG_REMOVAL",
  UPSCALE: "UPSCALE"
}, c = {
  DAILY_CAP_REACHED: "DAILY_CAP_REACHED",
  MODERATION_BLOCKED: "MODERATION_BLOCKED",
  SPEND_LIMIT: "SPEND_LIMIT",
  NOT_CONFIGURED: "NOT_CONFIGURED",
  MODEL_ERROR: "MODEL_ERROR",
  ENQUEUE_FAILED: "ENQUEUE_FAILED",
  ASPECT_UNSUPPORTED: "ASPECT_UNSUPPORTED",
  AI_IMAGE_EDITS_DISABLED: X.AI_IMAGE_EDITS_DISABLED
};
new Set(
  Object.values(c)
);
const J = {
  EDITING: "EDITING",
  PROOF_SENT: "PROOF_SENT",
  FINALIZED: "FINALIZED",
  CLOSED: "CLOSED"
}, a = {
  EN: "EN",
  ES: "ES",
  FR: "FR"
};
Object.values(a);
const _ = {
  "Standard Theme Design": {
    prompt: "imagePlacement",
    steps: ({ imagePlacementChoice: o }) => o === "self" ? ["placement", "review"] : ["review"]
  },
  // The designer invents the background, so the theme selector is replaced by
  // the custom-theme brief; Continue goes straight to the review modal.
  "Custom Theme Design": {
    prompt: "customTheme",
    steps: () => ["review"]
  },
  // The order-of-service content rides in as a document upload or typed
  // text below the case dropdown; Continue goes straight to review.
  "Order of Service Partner": {
    prompt: "orderOfService",
    steps: () => ["review"]
  },
  // The requested layout adjustments ride in as free text below the case
  // dropdown; Continue goes straight to review.
  "Layout Partner": {
    prompt: "layoutChanges",
    steps: () => ["review"]
  },
  // Photo selections + edit comments are normally collected on the product
  // page; the modal step only runs when the customer hits Continue without
  // finishing them.
  "Photograph Editor": {
    prompt: "photoEdits",
    steps: ({ photoEditsComplete: o }) => o ? ["review"] : ["photoEdits", "review"]
  },
  // The extra photos (uploaded through the case-image pipeline or picked
  // from existing case images) are normally collected on the product page;
  // the modal step only runs when Continue is hit without any added.
  "Additional Photos": {
    prompt: "additionalPhotos",
    steps: ({ additionalPhotosComplete: o }) => o ? ["review"] : ["additionalPhotos", "review"]
  }
}, ee = "Signature by Beryl", te = {
  [ee]: "Standard Theme Design",
  "Design my product using a standard theme": "Standard Theme Design",
  "Design my product using a custom theme": "Custom Theme Design",
  "Add an order of service": "Order of Service Partner",
  "Design my layouts": "Layout Partner",
  "Edit my photos": "Photograph Editor",
  "Add more photos": "Additional Photos"
};
new Map([
  ...Object.entries(_).map(
    ([o, n]) => [o.toLowerCase(), n]
  ),
  ...Object.entries(te).map(
    ([o, n]) => [o.toLowerCase(), _[n]]
  )
]);
const oe = [
  "unassigned",
  "assigned",
  "approved",
  "completed",
  "canceled"
], ne = (o) => o.trim().replace(/^['"]|['"]$/g, ""), ae = (o) => ne(o.split(",")[0] ?? ""), ie = /^[A-Za-z0-9_-]*$/, r = e.enum(N).optional().default("MDL"), Ke = e.object({
  categoryId: t.optional(),
  getAllAssets: e.boolean().optional()
}), Xe = e.object({
  categoryId: e.string().trim().pipe(t),
  name: e.string().trim()
}), Ye = e.object({
  categoryId: e.string().trim().pipe(t).optional(),
  name: e.string().trim().optional()
}), re = e.object({
  subcategoryId: t.optional(),
  name: e.string().trim().optional()
}), Je = e.object({
  subcategoryId: t,
  name: e.string().trim(),
  image: e.string().trim()
}), et = re.extend({
  image: e.string().trim().optional()
}), tt = e.object({
  productId: t.optional(),
  themeId: t.optional()
}), ot = e.object({
  productId: t,
  themeId: t,
  fontFamily: e.string(),
  textColor: e.string()
}), nt = e.object({
  productId: t.optional().nullable(),
  themeId: t.optional().nullable(),
  fontFamily: e.string().optional().nullable(),
  textColor: e.string().optional().nullable()
}), le = 25, F = Object.values(K), L = e.enum(F), v = (o) => new Set(o).size === o.length, M = e.strictObject({
  order: e.array(L).length(F.length).refine(v, {
    error: "order must hold every part once"
  }),
  hidden: e.array(L).refine(v, {
    error: "hidden must list a part once"
  })
}), I = (o) => Array.isArray(o) ? o.filter(
  (n) => n && typeof n == "object" && "name" in n && typeof n.name == "string" && n.name.trim() !== ""
) : o, at = e.object({
  limit: e.coerce.number().int().min(1).max(50).optional().default(le),
  page: e.coerce.number().int().min(1).optional().default(1),
  archived: e.coerce.boolean().default(!1),
  searchTerm: e.string().optional(),
  recentOnly: e.coerce.boolean().default(!0)
}), f = e.array(
  e.object({
    id: e.string().optional().nullable(),
    location: e.string().trim().nullable().optional(),
    time: e.string().trim().nullable().optional(),
    date: e.string().nullable().optional(),
    type: e.string().trim().nonempty(),
    default: e.boolean().default(!1),
    city: e.string().trim().nullable().optional(),
    state: e.string().trim().nullable().optional(),
    address: e.string().trim().nullable().optional(),
    clergyPlace: e.string().trim().nullable().optional(),
    country: e.string().trim().nullable().optional(),
    endTime: e.string().trim().nullable().optional(),
    postalCode: e.string().trim().nullable().optional(),
    roomChapel: e.string().trim().nullable().optional(),
    startTime: e.string().trim().nullable().optional()
  })
).nullable().optional(), se = (o) => Array.isArray(o) ? o.filter(
  (n) => !(n !== null && typeof n == "object" && "name" in n && typeof n.name == "string" && n.name.trim() === "")
) : o, S = e.union([
  e.preprocess(
    se,
    e.array(
      e.object({
        name: e.string().trim().min(1, {
          error: "Name cannot be empty or just spaces"
        }),
        relation: e.string().trim().nullable().optional(),
        type: e.string().trim().min(1, {
          error: "Type cannot be empty or just spaces"
        }),
        city: e.string().trim().nullable().optional(),
        country: e.string().trim().nullable().optional(),
        state: e.string().trim().nullable().optional(),
        id: e.string().optional().nullable()
      })
    ).optional()
  ),
  e.string().trim().optional()
]).nullable().optional(), y = e.preprocess(
  I,
  e.array(
    e.object({
      name: e.string().trim().nonempty(),
      sequence: e.union([e.string().trim().nonempty(), e.number()]),
      charityOfChoice: e.boolean(),
      id: e.string().optional().nullable()
    })
  ).nullable().optional()
), T = e.preprocess(
  I,
  e.array(
    e.object({
      name: e.string().trim().nonempty(),
      sequence: e.union([e.string().trim(), e.number()]).nullable().optional(),
      type: e.string().trim().nonempty(),
      id: e.string().optional().nullable()
    })
  ).nullable().optional()
), O = e.preprocess(
  I,
  e.array(
    e.object({
      name: e.string().trim().nonempty(),
      sequence: e.union([e.string().trim().nonempty(), e.number()]),
      city: e.string().trim().nullable().optional(),
      state: e.string().trim().nullable().optional(),
      zipCode: e.string().trim().nullable().optional(),
      country: e.string().trim().nullable().optional(),
      websiteUrl: e.string().trim().nullable().optional(),
      address1: e.string().trim().nullable().optional(),
      address2: e.string().trim().nullable().optional(),
      id: e.string().optional().nullable()
    })
  ).nullable().optional()
), it = e.object({
  birth_header: e.string().optional(),
  death_header: e.string().optional(),
  remembrance_header: e.string().optional(),
  officiating_header: e.string().optional(),
  memorial_service_header: e.string().optional(),
  final_resting_header: e.string().optional(),
  pallbearers_header: e.string().optional(),
  visitation_header: e.string().optional(),
  family_appreciation_header: e.string().optional()
}), j = e.object({
  birthHeader: e.string().trim().optional(),
  deathHeader: e.string().trim().optional(),
  remembranceHeader: e.string().trim().optional(),
  officiatingHeader: e.string().trim().optional(),
  memorialServiceHeader: e.string().trim().optional(),
  finalRestingHeader: e.string().trim().optional(),
  pallbearersHeader: e.string().trim().optional(),
  visitationHeader: e.string().trim().optional(),
  familyAppreciationHeader: e.string().trim().optional()
}).nullable().optional(), me = 2048, ce = /^https?:\/\//i, pe = /^[a-z0-9-]+(\.[a-z0-9-]+)+(:\d+)?([/?#]|$)/i, ue = (o) => {
  if (o === "") return !0;
  const n = ce.test(o) ? o : pe.test(o) ? `https://${o}` : null;
  if (!n) return !1;
  try {
    const i = new URL(n);
    return (i.protocol === "http:" || i.protocol === "https:") && !!i.hostname;
  } catch {
    return !1;
  }
}, x = e.string().max(me).refine(ue, {
  error: "returnUrl must be an http(s) URL or a host name without a scheme"
}).nullable().optional(), de = e.object({
  nameOfDeceased: e.coerce.string().trim().nullable().optional(),
  nameArrangement: M.optional(),
  editableCaseId: e.string().trim().nullable().optional(),
  dateOfBirth: e.string().nullable().optional(),
  placeOfBirth: e.string().trim().nullable().optional(),
  dateOfDeath: e.string().nullable().optional(),
  placeOfDeath: e.string().trim().nullable().optional(),
  motherOfDeceased: e.string().trim().nullable().optional(),
  fatherOfDeceased: e.string().trim().nullable().optional(),
  spouse: e.string().trim().nullable().optional(),
  dateOfMarriage: e.coerce.date().nullable().optional(),
  maternalGrandmother: e.string().trim().nullable().optional(),
  maternalGrandmothersMother: e.string().trim().nullable().optional(),
  maternalGrandmothersFather: e.string().trim().nullable().optional(),
  maternalGrandfather: e.string().trim().nullable().optional(),
  maternalGrandfathersMother: e.string().trim().nullable().optional(),
  maternalGrandfathersFather: e.string().trim().nullable().optional(),
  paternalGrandmother: e.string().trim().nullable().optional(),
  paternalGrandmothersMother: e.string().trim().nullable().optional(),
  paternalGrandmothersFather: e.string().trim().nullable().optional(),
  paternalGrandfather: e.string().trim().nullable().optional(),
  paternalGrandfathersMother: e.string().trim().nullable().optional(),
  paternalGrandfathersFather: e.string().trim().nullable().optional(),
  children: e.array(e.string()).default([]),
  siblings: e.array(e.string()).default([]),
  organizations: O,
  songs: e.array(e.string()).default([]),
  pallbearers: T,
  obituary: e.string().trim().nullable().optional(),
  familyAppreciationMessage: e.string().trim().nullable().optional(),
  services: f,
  additionalFamily: S,
  clergy: e.array(e.string()).default([]),
  intermentPlace: e.string().trim().nullable().optional(),
  intermentLot: e.string().trim().nullable().optional(),
  intermentSection: e.string().trim().nullable().optional(),
  intermentBlock: e.string().trim().nullable().optional(),
  intermentCity: e.string().trim().nullable().optional(),
  intermentState: e.string().trim().nullable().optional(),
  intermentDate: e.string().nullable().optional(),
  intermentCounty: e.string().trim().nullable().optional(),
  intermentTime: e.string().trim().nullable().optional(),
  createdOnBehalfOfEmail: e.string().trim().optional(),
  intermentAddress: e.string().trim().optional(),
  lastdec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  firstDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  maidenDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  middleDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  nickNameDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  prefixDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  suffixDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  websiteObitUrl: e.string().trim().optional(),
  orderOfService: e.string().trim().optional(),
  memorialContributions: y,
  returnUrl: x,
  intermentPostalCode: e.string().trim().optional(),
  casePreferences: j
}), rt = e.object({
  nameOfDeceased: e.coerce.string().trim().nullable().optional(),
  nameArrangement: M.optional(),
  editableCaseId: e.string().trim().nullable().optional(),
  dateOfBirth: e.string().nullable().optional(),
  placeOfBirth: e.string().trim().nullable().optional(),
  dateOfDeath: e.string().nullable().optional(),
  placeOfDeath: e.string().trim().nullable().optional(),
  motherOfDeceased: e.string().trim().nullable().optional(),
  fatherOfDeceased: e.string().trim().nullable().optional(),
  spouse: e.string().trim().nullable().optional(),
  dateOfMarriage: e.coerce.date().nullable().optional(),
  maternalGrandmother: e.string().trim().nullable().optional(),
  maternalGrandmothersMother: e.string().trim().nullable().optional(),
  maternalGrandmothersFather: e.string().trim().nullable().optional(),
  maternalGrandfather: e.string().trim().nullable().optional(),
  maternalGrandfathersMother: e.string().trim().nullable().optional(),
  maternalGrandfathersFather: e.string().trim().nullable().optional(),
  paternalGrandmother: e.string().trim().nullable().optional(),
  paternalGrandmothersMother: e.string().trim().nullable().optional(),
  paternalGrandmothersFather: e.string().trim().nullable().optional(),
  paternalGrandfather: e.string().trim().nullable().optional(),
  paternalGrandfathersMother: e.string().trim().nullable().optional(),
  paternalGrandfathersFather: e.string().trim().nullable().optional(),
  children: e.array(e.string()).optional(),
  siblings: e.array(e.string()).optional(),
  organizations: O,
  songs: e.array(e.string()).optional(),
  pallbearers: T,
  obituary: e.string().trim().nullable().optional(),
  familyAppreciationMessage: e.string().trim().nullable().optional(),
  services: f,
  additionalFamily: S,
  clergy: e.array(e.string()).optional(),
  intermentPlace: e.string().trim().nullable().optional(),
  intermentLot: e.string().trim().nullable().optional(),
  intermentSection: e.string().trim().nullable().optional(),
  intermentBlock: e.string().trim().nullable().optional(),
  intermentCity: e.string().trim().nullable().optional(),
  intermentState: e.string().trim().nullable().optional(),
  intermentDate: e.string().nullable().optional(),
  intermentCounty: e.string().trim().nullable().optional(),
  intermentTime: e.string().trim().nullable().optional(),
  createdOnBehalfOfEmail: e.string().trim().optional(),
  intermentAddress: e.string().trim().optional(),
  lastdec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  firstDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  maidenDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  middleDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  nickNameDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  prefixDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  suffixDec: e.union([e.string(), e.boolean()]).transform((o) => typeof o == "boolean" ? o ? "True" : "False" : o.trim()).nullable().optional(),
  websiteObitUrl: e.string().trim().optional(),
  orderOfService: e.string().trim().optional(),
  memorialContributions: y,
  returnUrl: x,
  intermentPostalCode: e.string().trim().optional(),
  casePreferences: j
}), lt = e.object({
  services: f,
  additionalFamily: S,
  memorialContributions: y,
  pallbearers: T,
  organizations: O,
  casePreferences: j
}), st = e.object({
  caseId: t,
  contentType: e.string().regex(/^image\//, "contentType must be an image MIME type")
}), mt = e.object({
  caseId: t,
  s3Key: e.string().min(1),
  originalFileName: e.string().optional(),
  // Stores the upload as it is, without the automatic enhancement: a
  // Liminal Touch QR code must scan exactly as it was generated. The
  // `process` procedure refuses it for any other upload.
  skipEnhancement: e.boolean().optional()
}), ct = e.object({
  caseId: t,
  imageUrl: e.url()
}), pt = e.object({
  caseId: t,
  fromIndex: e.int().nonnegative()
}), ut = e.object({
  caseId: t,
  contentTypes: e.array(
    e.string().regex(/^image\//, "contentType must be an image MIME type")
  ).min(1).max(20)
}), dt = e.object({
  caseId: t,
  items: e.array(
    e.object({
      s3Key: e.string().min(1),
      originalFileName: e.string().optional()
    })
  ).min(1).max(20)
}), gt = e.object({
  jobIds: e.array(e.string().min(1)).min(1).max(20)
}), bt = e.object({
  token: e.string().min(1),
  contentType: e.string().regex(/^image\//, "contentType must be an image MIME type")
}), ht = e.object({
  token: e.string().min(1),
  s3Key: e.string().min(1),
  originalFileName: e.string().optional()
}), It = e.object({
  token: e.string().min(1),
  imageUrl: e.url()
}), ft = e.object({
  token: e.string().min(1)
}), St = e.object({
  token: e.string().min(1),
  imageUrl: e.url()
}), yt = e.object({
  token: e.string().min(1)
}), b = `targetSize edges must be whole pixels from 1 to ${U}`, ge = "targetSize is only accepted with kind UPSCALE", R = e.int({ error: b }).min(1, { error: b }).max(U, {
  error: b
}), be = e.object({
  width: R,
  height: R
}), Tt = e.object({
  caseImageId: t,
  kind: e.enum(m),
  sourceVariantId: t.optional(),
  targetSize: be.optional()
}).refine(
  (o) => o.targetSize === void 0 || o.kind === m.UPSCALE,
  { error: ge, path: ["targetSize"] }
), Ot = e.object({
  code: e.enum([
    c.DAILY_CAP_REACHED,
    c.ASPECT_UNSUPPORTED
  ])
}), z = e.object({
  id: t,
  kind: e.enum(m),
  status: e.enum(Y),
  url: e.string().nullable(),
  sourceVariantId: t.nullable(),
  accepted: e.boolean(),
  revertedAt: e.iso.datetime().nullable(),
  errorCode: e.enum(c).nullable(),
  createdAt: e.iso.datetime()
}), jt = e.object({
  variants: e.array(z)
}), he = z.extend({
  caseImageId: t
}), Pt = e.object({
  variants: e.array(he)
}), Et = e.object({
  reverted: e.boolean()
}), Ct = e.object({
  variantId: t,
  revertedAt: e.iso.datetime().nullable()
}), Dt = e.object({
  [m.BG_REMOVAL]: e.int().nonnegative(),
  [m.UPSCALE]: e.int().nonnegative()
}), At = e.object({
  enabled: e.boolean()
}), _t = e.object({
  caseId: e.string(),
  archived: e.coerce.boolean().default(!1)
}), Lt = e.object({
  memorial: e.string().trim(),
  submitterName: e.string().trim(),
  caseId: e.string()
}), vt = e.object({
  htmlForRender: e.string().trim(),
  html: e.string().trim(),
  reference: e.string().trim(),
  isGlobal: e.boolean().optional().nullable(),
  imageUrl: e.string().optional().nullable(),
  location: e.string().optional().nullable(),
  type: e.enum(["HTML", "IMAGE"]).default("HTML"),
  themeId: t.optional().nullable(),
  baseProductId: t.optional().nullable(),
  orderProductId: t.optional().nullable()
}), Rt = e.object({
  themeId: t.optional().nullable(),
  baseProductId: t.optional().nullable(),
  orderProductId: t.optional().nullable()
}), B = e.enum(["button", "thumbnail"]), P = e.enum([
  "base",
  "enhancement",
  "theme",
  "template",
  "dynamic_content"
]), G = e.enum([
  "all",
  "specific",
  "all_plus_specific",
  "all_except"
]), Ie = e.object({
  customizationLabel: e.string(),
  optionLabels: e.array(e.string())
}), p = e.object({
  label: e.string().trim().min(1),
  image: e.string().optional(),
  iconAssetUrl: e.url().optional(),
  sortOrder: e.int().optional(),
  available: e.boolean().optional(),
  description: e.string().optional(),
  themeId: t.optional(),
  dependsOn: e.array(Ie).optional()
}), Ut = p.partial(), fe = e.strictObject({
  productId: t,
  label: e.string().trim().min(1),
  displayType: B.default("button"),
  customizationType: P.default("base"),
  setDefault: e.boolean().optional(),
  defaultOption: t.optional(),
  available: e.boolean().default(!0),
  sortOrder: e.int().min(0).optional(),
  themeMode: G.optional(),
  options: e.array(p).optional()
}), Nt = fe.refine(
  (o) => !(o.setDefault === !0 && !o.defaultOption),
  {
    path: ["defaultOption"],
    error: "defaultOption is required when setDefault is true"
  }
).refine(
  (o) => {
    if (o.defaultOption)
      try {
        return t.parse(o.defaultOption), !0;
      } catch {
        return !1;
      }
    return !0;
  },
  {
    path: ["defaultOption"],
    error: "defaultOption must be a valid UUID"
  }
).refine(
  (o) => {
    if (o.options && o.options.length > 0) {
      const n = o.options.map((l) => l.label.toLowerCase()), i = new Set(n);
      return n.length === i.size;
    }
    return !0;
  },
  {
    path: ["options"],
    error: "Option labels must be unique (case-insensitive)"
  }
), Se = e.strictObject({
  productId: t.optional(),
  label: e.string().trim().min(1).optional(),
  displayType: B.optional(),
  customizationType: P.optional(),
  setDefault: e.boolean().optional(),
  defaultOption: t.optional(),
  available: e.boolean().optional(),
  sortOrder: e.int().min(0).optional(),
  themeMode: G.nullable().optional(),
  options: e.array(p).optional(),
  archived: e.boolean().optional()
}), Ft = Se.refine(
  (o) => !(o.setDefault === !0 && !o.defaultOption),
  {
    path: ["defaultOption"],
    error: "defaultOption is required when setDefault is true"
  }
).refine(
  (o) => {
    if (o.defaultOption)
      try {
        return t.parse(o.defaultOption), !0;
      } catch {
        return !1;
      }
    return !0;
  },
  {
    path: ["defaultOption"],
    error: "defaultOption must be a valid UUID"
  }
).refine(
  (o) => {
    if (o.options && o.options.length > 0) {
      const n = o.options.map((l) => l.label.toLowerCase()), i = new Set(n);
      return n.length === i.size;
    }
    return !0;
  },
  {
    path: ["options"],
    error: "Option labels must be unique (case-insensitive)"
  }
), Mt = e.object({
  productId: t.optional(),
  archived: e.boolean().optional(),
  available: e.boolean().optional(),
  customizationType: P.optional()
}), xt = e.object({
  id: t
}), zt = e.object({
  id: t
}), Bt = e.object({
  options: e.array(p).min(1)
}), E = e.object({
  customizationId: t,
  selectedOptionId: t
}), C = e.record(e.string(), e.string()), Gt = e.object({
  bucket: e.enum(oe).optional()
}), Ht = e.object({
  id: t
}), wt = e.object({
  themeOverrideId: e.string(),
  archived: e.coerce.boolean().default(!1)
}), kt = e.object({
  caseId: t
}), h = (o) => typeof o == "string" && o.trim() === "" ? null : o, ye = /^[\d\s+().-]{7,32}$/, Vt = e.object({
  caseId: t,
  name: e.preprocess(
    h,
    e.string().trim().max(200).nullable().optional()
  ),
  email: e.preprocess(
    h,
    e.string().trim().pipe(e.email().max(254)).nullable().optional()
  ),
  phone: e.preprocess(
    h,
    e.string().trim().regex(ye).nullable().optional()
  ),
  smsConsent: e.boolean().optional()
}), qt = (o) => typeof o == "object" && o !== null && o.name === "ZodError" && Array.isArray(o.issues), Te = (o, n) => {
  o.issues.push({
    code: "custom",
    input: o.value,
    continue: !0,
    ...n
  });
}, Oe = e.strictObject({
  pageId: t,
  content: e.string().min(1),
  loadedRunId: e.string().min(1).max(128).nullable(),
  boxes: e.array(e.unknown()),
  deleteBoxIds: e.array(e.string().min(1)).default([])
}), Qt = e.strictObject({
  applicationType: e.enum(N),
  coveringVersionNumber: e.int().positive(),
  runId: e.string().min(1).max(128),
  pages: e.array(Oe).min(1)
}).check((o) => {
  const { value: n } = o, i = /* @__PURE__ */ new Set();
  for (const [l, g] of n.pages.entries())
    i.has(g.pageId) && Te(o, {
      path: ["pages", l, "pageId"],
      message: `page "${g.pageId}" appears twice — one entry per page`
    }), i.add(g.pageId);
}), je = {
  maxRetries: 2,
  maxWaitMs: 1e4,
  timeoutMs: 12e4
}, $t = () => {
  const { maxRetries: o, maxWaitMs: n, timeoutMs: i } = je;
  return o * (n + i);
}, H = e.enum(["button", "thumbnail"]), D = e.enum([
  "base",
  "enhancement",
  "theme",
  "template"
]), Pe = e.enum(["GOOD", "BETTER", "BEST"]), w = e.enum([
  "all",
  "specific",
  "all_plus_specific",
  "all_except"
]), A = e.object({
  label: e.string().trim().min(1),
  image: e.string().optional(),
  sortOrder: e.int().optional(),
  available: e.boolean().optional(),
  quality: Pe.optional(),
  description: e.string().optional(),
  themeId: t.optional(),
  dependsOn: e.array(
    e.object({
      customizationLabel: e.string(),
      optionLabels: e.array(e.string())
    })
  ).optional()
}), Wt = A.partial(), Zt = e.strictObject({
  categoryId: t,
  productId: t.optional(),
  label: e.string().trim().min(1),
  displayType: H,
  customizationType: D.default("base"),
  setDefault: e.boolean().optional(),
  defaultOption: t.optional(),
  available: e.boolean().default(!0),
  sortOrder: e.int().min(0).optional(),
  themeMode: w.optional(),
  options: e.array(A).optional()
}).refine(
  (o) => !(o.setDefault === !0 && !o.defaultOption),
  {
    path: ["defaultOption"],
    error: "defaultOption is required when setDefault is true"
  }
).refine(
  (o) => {
    if (o.defaultOption)
      try {
        return t.parse(o.defaultOption), !0;
      } catch {
        return !1;
      }
    return !0;
  },
  {
    path: ["defaultOption"],
    error: "defaultOption must be a valid UUID"
  }
).refine(
  (o) => {
    if (o.options && o.options.length > 0) {
      const n = o.options.map((l) => l.label.toLowerCase()), i = new Set(n);
      return n.length === i.size;
    }
    return !0;
  },
  {
    path: ["options"],
    error: "Option labels must be unique (case-insensitive)"
  }
), Kt = e.strictObject({
  categoryId: t.optional(),
  productId: t.optional(),
  label: e.string().trim().min(1).optional(),
  displayType: H.optional(),
  customizationType: D.optional(),
  setDefault: e.boolean().optional(),
  defaultOption: t.optional(),
  available: e.boolean().optional(),
  sortOrder: e.int().min(0).optional(),
  themeMode: w.nullable().optional(),
  options: e.array(A).optional(),
  archived: e.boolean().optional()
}).refine(
  (o) => !(o.setDefault === !0 && !o.defaultOption),
  {
    path: ["defaultOption"],
    error: "defaultOption is required when setDefault is true"
  }
).refine(
  (o) => {
    if (o.defaultOption)
      try {
        return t.parse(o.defaultOption), !0;
      } catch {
        return !1;
      }
    return !0;
  },
  {
    path: ["defaultOption"],
    error: "defaultOption must be a valid UUID"
  }
).refine(
  (o) => {
    if (o.options && o.options.length > 0) {
      const n = o.options.map((l) => l.label.toLowerCase()), i = new Set(n);
      return n.length === i.size;
    }
    return !0;
  },
  {
    path: ["options"],
    error: "Option labels must be unique (case-insensitive)"
  }
), Xt = e.object({
  categoryId: t.optional(),
  productId: t.optional(),
  archived: e.boolean().optional(),
  available: e.boolean().optional(),
  customizationType: D.optional()
}), Yt = e.object({
  id: t
}), Jt = e.object({
  id: t
}), Ee = e.enum([
  "paper_stock",
  "cover",
  "binding",
  "envelope"
]), eo = e.object({
  type: Ee
}), Ce = e.enum(["PLAIN", "PREPRINTED"]), k = e.object({
  name: e.string().trim().min(1),
  itmRef: e.string().trim().min(1),
  priceCode: e.string().trim().min(1),
  priceTable: e.string().trim().min(1),
  description: e.string().trim().optional(),
  quantityIncrements: e.int().positive().optional(),
  minimumQuantity: e.int().positive().optional(),
  fontColor: e.string().optional(),
  themeId: t.optional(),
  paperWidth: e.number().positive().optional(),
  paperHeight: e.number().positive().optional(),
  // Editor-canvas pixel dimensions. Transient: used only to seed default
  // layout page content, never persisted — theme_width/theme_height columns
  // always mirror paper_width/paper_height (inches), same as MDL.
  widthPixels: e.number().positive().optional(),
  heightPixels: e.number().positive().optional(),
  foldLine: e.string().optional(),
  marginTop: e.int().min(0).optional(),
  marginRight: e.int().min(0).optional(),
  marginBottom: e.int().min(0).optional(),
  marginLeft: e.int().min(0).optional(),
  marginCenterHorizontal: e.int().min(0).optional(),
  marginCenterVertical: e.int().min(0).optional(),
  backgroundType: Ce.optional(),
  identifier: e.record(e.string(), e.string()).optional(),
  hasVariations: e.boolean().optional(),
  available: e.boolean().optional()
}), to = k.partial().extend({
  archived: e.boolean().optional()
}), oo = e.object({
  archived: e.boolean().optional(),
  available: e.boolean().optional(),
  priceCode: e.string().optional(),
  priceTable: e.string().optional(),
  searchTerm: e.string().optional()
}), no = e.object({
  id: t
}), ao = e.object({
  itmRef: e.string().min(1)
}), io = e.array(k), De = e.object({
  customizationId: t.optional(),
  selectedOptionId: t.optional(),
  themeId: t.optional()
}).refine(
  (o) => {
    const n = !!o.customizationId && !!o.selectedOptionId, i = !!o.themeId, l = (o.customizationId ? 1 : 0) + (o.selectedOptionId ? 1 : 0);
    return n && !i && l === 2 || i && l === 0;
  },
  {
    error: "Selection must be either { customizationId, selectedOptionId } or { themeId }"
  }
), Ae = e.object({
  baseProductId: t,
  name: e.string().trim().min(1),
  itmRef: e.string().trim().min(1),
  priceCode: e.string().trim().min(1),
  priceTable: e.string().trim().min(1),
  description: e.string().trim().optional(),
  selections: e.array(De).min(1)
}), ro = Ae.partial().extend({
  archived: e.boolean().optional()
}), lo = e.object({
  id: t
}), V = e.object({
  productId: t.optional(),
  productVariationId: t.optional(),
  categoryId: t.optional(),
  themeId: t,
  imageUrl: e.url(),
  sortOrder: e.int().min(0).optional()
}), so = V.partial().omit({
  productId: !0,
  productVariationId: !0,
  categoryId: !0
}), mo = e.object({
  id: t
}), co = e.object({
  productId: t.optional(),
  productVariationId: t.optional(),
  categoryId: t.optional(),
  themeId: t.optional()
}), po = e.array(
  V
), q = e.object({
  productId: t,
  quantity: e.int().positive().optional(),
  sortOrder: e.int().min(0).optional()
}), uo = e.object({
  funeralHomeId: t,
  name: e.string().trim().min(1, "Name is required"),
  description: e.string().trim().optional(),
  products: e.array(q).optional()
}), go = e.object({
  name: e.string().trim().min(1, "Name is required").optional(),
  description: e.string().trim().optional(),
  archived: e.boolean().optional(),
  products: e.array(q).optional()
}), bo = e.object({
  funeralHomeId: t.optional(),
  archived: e.boolean().optional(),
  searchTerm: e.string().optional()
}), ho = e.object({
  id: t
}), Io = e.object({
  bundleId: t,
  productId: t,
  quantity: e.int().positive().optional(),
  sortOrder: e.int().min(0).optional()
}), fo = e.object({
  bundleId: t,
  productId: t
}), So = e.object({
  bundleId: t,
  productId: t,
  quantity: e.int().positive()
}), _e = e.object({
  name: e.string().trim().min(1, "Name is required"),
  description: e.string().trim().optional(),
  image: e.string().trim().optional(),
  short_code: e.string().trim().optional(),
  available: e.boolean().optional()
}), yo = e.object({
  name: e.string().trim().min(1, "Name is required").optional(),
  description: e.string().trim().optional(),
  image: e.string().trim().optional().nullable(),
  short_code: e.string().trim().optional(),
  available: e.boolean().optional()
}), To = e.object({
  available: e.boolean().optional(),
  searchTerm: e.string().optional()
}), Oo = e.object({
  id: t
}), jo = e.object({
  id: t,
  available: e.boolean()
}), Po = e.array(
  _e
), Eo = e.object({
  applicationType: r,
  orderPageSetId: t
}), Co = e.object({
  archived: e.boolean().default(!1)
}), Do = e.object({
  pageSetId: e.string().optional(),
  orderPageSetId: e.string().optional(),
  homeTemplate: e.string().optional(),
  default: e.boolean().optional(),
  json_template: e.string().optional(),
  archived: e.boolean().default(!1)
}), Ao = e.object({
  applicationType: r,
  orderPageSetId: t
}), _o = e.object({
  id: t
}), Lo = e.object({
  caseId: t.optional(),
  themeId: t.nullable().optional(),
  archived: e.coerce.boolean().optional().default(!1),
  language: e.enum(a).optional()
}), vo = e.object({
  caseId: t.optional(),
  themeId: t.nullable().optional(),
  archived: e.coerce.boolean().optional().default(!1),
  language: e.enum(a).optional(),
  m3OrderProductId: t.optional()
}), Ro = e.object({
  applicationType: r.optional(),
  orderId: t.optional(),
  caseId: t.optional()
}).refine((o) => !!(o.orderId || o.caseId), {
  path: ["orderId"],
  error: "Either orderId or caseId is required"
}), Uo = e.object({
  orderId: t.optional()
}), No = e.object({
  applicationType: r,
  name: e.string().trim().optional(),
  selected: e.coerce.boolean().optional(),
  archived: e.coerce.boolean().optional(),
  status: e.enum(J).optional(),
  themeId: t.nullable().optional()
}), Fo = e.object({
  applicationType: e.enum(["M3", "MDL"]).optional(),
  funeralHomeId: t.optional(),
  name: e.string().trim().optional(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  orderProductId: t.optional(),
  id: t.optional(),
  language: e.enum(a).optional()
}), Mo = e.object({
  applicationType: r,
  gridStartPointTop: e.number().optional(),
  gridStartPointLeft: e.number().optional(),
  pageNumber: e.number().optional(),
  columns: e.number().optional(),
  rows: e.number().optional(),
  content: e.string().optional(),
  jsonTemplate: e.string().optional(),
  /**
   * Why the client is writing this page, recorded as the reason of the
   * version snapshot the write takes. Absent means a person saved the page
   * (`page_save`); `watermark_sync` is the customize page writing the theme's
   * watermarks onto page 1 with nobody editing. The values mirror
   * SNAPSHOT_REASONS in @messenger/utils.
   */
  saveReason: e.enum(["page_save", "watermark_sync"]).optional(),
  /**
   * The version the client already took for the Save this write belongs to.
   * When that version holds this page as it stands, the write takes no
   * version of its own and the whole Save is covered by one. Absent — from an
   * older client, or a write that is not part of a Save — leaves every write
   * taking its own.
   */
  coveringVersionNumber: e.int().positive().optional()
}), u = e.string().trim().max(50).nullable().transform((o) => o || null).optional(), xo = e.object({
  name: e.string().trim(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  orderId: t,
  // Left out, a line is not selected.
  selected: e.coerce.boolean().default(!1),
  themeId: t.optional(),
  // Per-line language override. null/omitted = inherit the order language.
  language: e.enum(a).nullable().optional(),
  nickname: u
}), zo = e.object({
  caseId: t,
  themeId: t.optional(),
  language: e.enum(a).optional().default(a.EN)
}), Bo = e.object({
  caseId: t.optional(),
  themeId: t.nullable().optional(),
  status: e.string().optional(),
  language: e.enum(a).optional()
}), Go = e.object({
  name: e.string().trim().optional(),
  available: e.coerce.boolean().optional(),
  default: e.coerce.boolean().optional(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  orderProductDetailsId: t.optional()
}), Ho = e.object({
  name: e.string().trim().optional(),
  available: e.coerce.boolean().optional(),
  default: e.coerce.boolean().optional(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  orderProductDetailsId: t.optional()
}), wo = e.object({
  applicationType: r,
  orderPageSetId: t,
  gridStartPointTop: e.number(),
  gridStartPointLeft: e.number(),
  rows: e.number(),
  columns: e.number(),
  pageNumber: e.number(),
  jsonTemplate: e.string(),
  sourcePageId: t.optional()
}), ko = e.object({
  applicationType: r,
  templateId: t,
  templateType: e.enum(["GLOBAL", "FUNERAL_HOME"]),
  pages: e.array(
    e.object({
      gridStartPointTop: e.number(),
      gridStartPointLeft: e.number(),
      rows: e.number(),
      columns: e.number(),
      pageNumber: e.number(),
      jsonTemplate: e.string(),
      sourcePageId: t
    })
  ).min(1)
}), Vo = e.object({
  applicationType: r,
  name: e.string().trim(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  orderProductId: t,
  pageSetId: t,
  homeTemplate: e.boolean().optional(),
  default: e.boolean().optional(),
  language: e.enum(a).optional().default(a.EN)
}), qo = e.object({
  applicationType: r,
  orderId: t
}), Qo = e.object({
  applicationType: r,
  name: e.string().trim().optional(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  pageSetId: t.optional(),
  funeralHomeTemplateId: t.optional(),
  globalTemplateId: t.optional(),
  default: e.boolean().optional(),
  language: e.enum(a).optional(),
  type: e.enum(["GLOBAL", "FUNERAL_HOME"]).optional(),
  currentOrderPageSetIdUsed: t.optional()
}), $o = e.object({
  applicationType: r
}), Wo = e.object({
  ids: e.array(t).min(1),
  applicationType: e.enum(["M3", "MDL"]).optional()
}), Zo = e.object({
  caseId: t,
  orderId: t
}), Ko = e.object({
  orderId: t,
  language: e.enum(a)
}), Le = e.object({
  id: e.string().trim().pipe(t).optional(),
  productId: e.string().trim(),
  themeId: e.string().trim().optional(),
  // Per-line language. Language is materialized on every line (theme parity):
  // omitted on create = the order language is written onto the line; `null` on
  // update = reset the line back to the order language. Omit on update to
  // leave the stored value unchanged.
  language: e.enum(a).nullable().optional(),
  // Per-line label shown as "Name (nickname)". `null` (or "") clears it;
  // omit to leave the stored value unchanged.
  nickname: u
}), Q = Le.extend({
  customizations: e.array(E).optional(),
  customizationsByLabel: C.optional()
}), $ = e.object({
  name: e.string().min(1),
  createdBy: e.string().optional().nullable(),
  canInsertImages: e.boolean().optional().nullable(),
  archived: e.boolean().optional().nullable()
}).optional().nullable(), Xo = e.object({
  funeralHome: e.object({
    id: e.string().trim().optional(),
    name: e.string().trim(),
    phone: e.string().nullable().optional(),
    address: e.string().nullable().optional(),
    city: e.string().nullable().optional(),
    state: e.string().nullable().optional(),
    zipCode: e.string().nullable().optional(),
    corporationId: e.string().nullable().optional(),
    active: e.boolean().default(!0),
    ipCity: e.string().nullable().optional(),
    ipCountryCode: e.string().nullable().optional(),
    ipCountryName: e.string().nullable().optional(),
    ipAddress: e.string().nullable().optional(),
    ipLatitude: e.number().nullable().optional(),
    ipLongitude: e.number().nullable().optional(),
    ipRegionCode: e.string().nullable().optional(),
    ipRegionName: e.string().nullable().optional(),
    ipZipCode: e.string().nullable().optional(),
    isServiceAuthenticated: e.boolean().default(!1),
    freeTrialStartedAt: e.date().nullable().optional(),
    serviceUrlSlug: e.string().nullable().optional(),
    stripeCustomerId: e.string().nullable().optional(),
    stripeSubscriptionStatus: e.string().nullable().optional(),
    stripeSubscriptionEndDate: e.date().nullable().optional(),
    address2: e.string().nullable().optional(),
    emailAddress: e.string().nullable().optional(),
    websiteUrl: e.string().nullable().optional()
  }),
  funeralHomeSettings: e.object({
    datesOfLifeFormat: e.string().max(150).optional(),
    datesOfServiceFormat: e.string().max(105).optional(),
    birthHeader: e.string().max(500).optional(),
    deathHeader: e.string().max(500).optional(),
    remembranceHeader: e.string().max(500).optional(),
    language: e.enum(a),
    timePeriod: e.string().max(50).optional(),
    timeRangeSeparator: e.string().max(10).optional(),
    showTimeNoon: e.boolean().optional(),
    removeMinutes: e.boolean().optional()
  }).optional(),
  user: e.object({
    id: e.string().trim().optional(),
    name: e.string().trim(),
    email: e.email(),
    corporationId: e.string().nullable().optional()
  }),
  case: de,
  // Optional so the middleware can create an empty order and add each line
  // afterwards via POST /api/order/:orderId/product; omitting the key is the
  // same as sending an empty array.
  products: e.union([
    e.string().array(),
    Q.array()
  ]).optional().default([]),
  themeId: e.string().trim(),
  corporation: $,
  language: e.enum(a).optional().default(a.EN)
}), Yo = e.object({
  funeralHome: e.object({
    id: e.string().trim().optional(),
    name: e.string().trim(),
    phone: e.string().nullable().optional(),
    address: e.string().nullable().optional(),
    city: e.string().nullable().optional(),
    state: e.string().nullable().optional(),
    zipCode: e.string().nullable().optional(),
    corporationId: e.string().nullable().optional(),
    active: e.boolean().default(!0),
    ipCity: e.string().nullable().optional(),
    ipCountryCode: e.string().nullable().optional(),
    ipCountryName: e.string().nullable().optional(),
    ipAddress: e.string().nullable().optional(),
    ipLatitude: e.number().nullable().optional(),
    ipLongitude: e.number().nullable().optional(),
    ipRegionCode: e.string().nullable().optional(),
    ipRegionName: e.string().nullable().optional(),
    ipZipCode: e.string().nullable().optional(),
    isServiceAuthenticated: e.boolean().default(!1),
    freeTrialStartedAt: e.date().nullable().optional(),
    serviceUrlSlug: e.string().nullable().optional(),
    stripeCustomerId: e.string().nullable().optional(),
    stripeSubscriptionStatus: e.string().nullable().optional(),
    stripeSubscriptionEndDate: e.date().nullable().optional(),
    address2: e.string().nullable().optional(),
    emailAddress: e.string().nullable().optional(),
    websiteUrl: e.string().nullable().optional()
  }).optional().nullable(),
  funeralHomeSettings: e.object({
    datesOfLifeFormat: e.string().max(150).optional(),
    datesOfServiceFormat: e.string().max(105).optional(),
    birthHeader: e.string().max(500).optional(),
    deathHeader: e.string().max(500).optional(),
    remembranceHeader: e.string().max(500).optional(),
    language: e.enum(a),
    timePeriod: e.string().max(50).optional(),
    timeRangeSeparator: e.string().max(10).optional(),
    showTimeNoon: e.boolean().optional(),
    removeMinutes: e.boolean().optional()
  }).optional().nullable(),
  user: e.object({
    id: e.string().trim().optional(),
    name: e.string().trim(),
    email: e.email(),
    corporationId: e.string().nullable().optional()
  }).optional().nullable(),
  corporation: $
}), Jo = e.object({
  products: e.union([
    e.string().array(),
    Q.array()
  ]).optional(),
  themeId: e.string().trim().optional(),
  resetProductLayoutIds: e.union([e.array(e.string()), e.boolean()]).optional(),
  language: e.enum(a).optional(),
  funeralHome: e.object({
    id: e.string().trim().optional(),
    name: e.string().trim().optional(),
    phone: e.string().nullable().optional(),
    address: e.string().nullable().optional(),
    city: e.string().nullable().optional(),
    state: e.string().nullable().optional(),
    zipCode: e.string().nullable().optional(),
    corporationId: e.string().nullable().optional(),
    active: e.boolean().optional(),
    ipCity: e.string().nullable().optional(),
    ipCountryCode: e.string().nullable().optional(),
    ipCountryName: e.string().nullable().optional(),
    ipAddress: e.string().nullable().optional(),
    ipLatitude: e.number().nullable().optional(),
    ipLongitude: e.number().nullable().optional(),
    ipRegionCode: e.string().nullable().optional(),
    ipRegionName: e.string().nullable().optional(),
    ipZipCode: e.string().nullable().optional(),
    isServiceAuthenticated: e.boolean().optional(),
    freeTrialStartedAt: e.date().nullable().optional(),
    serviceUrlSlug: e.string().nullable().optional(),
    stripeCustomerId: e.string().nullable().optional(),
    stripeSubscriptionStatus: e.string().nullable().optional(),
    stripeSubscriptionEndDate: e.date().nullable().optional(),
    address2: e.string().nullable().optional(),
    emailAddress: e.string().nullable().optional(),
    websiteUrl: e.string().nullable().optional()
  }).optional()
}), en = e.object({
  productId: e.string().trim().pipe(t),
  themeId: e.string().trim().pipe(t).optional(),
  // Per-line language override. Omit to inherit the order-level language.
  language: e.enum(a).optional(),
  // Per-line label shown as "Name (nickname)". Omit for no label.
  nickname: u,
  customizations: e.array(E).optional(),
  customizationsByLabel: C.optional()
}), tn = e.object({
  themeId: e.string().trim().pipe(t).optional(),
  // Per-line language override. An explicit `null` clears the override so
  // the line falls back to the order-level language; omit to leave as-is.
  language: e.enum(a).nullable().optional(),
  selected: e.boolean().optional(),
  // Per-line label shown as "Name (nickname)". `null` (or "") clears it;
  // omit to leave the stored value unchanged.
  nickname: u,
  customizations: e.array(E).optional(),
  customizationsByLabel: C.optional()
}).refine(
  (o) => o.themeId !== void 0 || o.language !== void 0 || o.selected !== void 0 || o.nickname !== void 0 || o.customizations !== void 0 || o.customizationsByLabel !== void 0,
  {
    error: "Provide at least one of: themeId, language, selected, nickname, customizations, customizationsByLabel"
  }
), on = e.object({
  actAsAdmin: e.boolean()
}), nn = e.object({
  locationGuid: s("Invalid location GUID format")
}), an = e.object({
  caseId: e.string().regex(/^\d+$/, "Case ID must be a number").transform(Number)
}), rn = e.object({
  funeralHomeId: e.string().regex(/^\d+$/, "Funeral Home ID must be a number").transform(Number)
}), ln = e.object({
  pattern: e.string().min(1, "Cache pattern is required")
}), sn = e.object({
  guid: s("Invalid location GUID format"),
  id: e.string().regex(/^\d+$/, "Case ID must be a number").transform(Number)
}), mn = e.object({
  guid: s("Invalid location GUID format"),
  caseId: e.string().regex(/^\d+$/, "Case ID must be a number").transform(Number)
}), cn = e.object({
  guid: s("Invalid location GUID format"),
  id: e.string().regex(/^\d+$/, "Case ID must be a number").transform(Number)
}), pn = e.object({
  guid: s("Invalid location GUID format")
}), un = e.object({
  dateDied: e.string().min(1, "dateDied parameter is required"),
  lastName: e.string().min(1, "lastName parameter is required")
}), dn = e.object({
  applicationType: r,
  id: t.optional(),
  name: e.string().trim().optional(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  themeId: t.optional(),
  customPages: e.coerce.boolean().optional(),
  homeTemplate: e.coerce.boolean().optional(),
  default: e.coerce.boolean().optional(),
  orderId: t.optional(),
  language: e.enum(a).optional()
}), gn = e.object({
  applicationType: r,
  id: t.optional(),
  name: e.string().trim().optional(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  themeId: t.optional(),
  customPages: e.coerce.boolean().optional(),
  homeTemplate: e.coerce.boolean().optional(),
  default: e.coerce.boolean().optional(),
  orderId: t.optional(),
  language: e.enum(a).optional()
}), bn = e.object({
  name: e.string().trim(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  themeId: t,
  homeTemplate: e.boolean(),
  default: e.coerce.boolean().default(!1),
  language: e.enum(a).default(a.EN),
  applicationType: r
}), hn = e.object({
  name: e.string().trim(),
  productId: t.optional(),
  m3ProductId: t.optional(),
  themeId: t,
  homeTemplate: e.coerce.boolean().default(!1),
  default: e.coerce.boolean().default(!1),
  language: e.enum(a).default(a.EN)
}), In = e.object({
  pageSetId: t,
  gridStartPointTop: e.number(),
  gridStartPointLeft: e.number(),
  rows: e.number(),
  columns: e.number(),
  pageNumber: e.number(),
  jsonTemplate: e.string(),
  sourceOrderPageId: t.optional()
}), W = e.object({
  gridStartPointTop: e.number(),
  gridStartPointLeft: e.number(),
  rows: e.number(),
  columns: e.number(),
  pageNumber: e.number(),
  jsonTemplate: e.string(),
  sourceOrderPageId: t
}), fn = e.object({
  name: e.string().trim(),
  default: e.boolean(),
  language: e.enum(a),
  homeTemplate: e.boolean(),
  pages: e.array(W).min(1)
}), Sn = e.object({
  name: e.string().trim(),
  productId: t.optional(),
  themeId: t,
  default: e.boolean(),
  language: e.enum(a).default(a.EN),
  pages: e.array(W).min(1)
}), yn = e.object({
  pageSetId: t.optional(),
  gridStartPointTop: e.number().optional(),
  gridStartPointLeft: e.number().optional(),
  rows: e.number().optional(),
  columns: e.number().optional(),
  pageNumber: e.number().optional(),
  template: e.string().optional(),
  jsonTemplate: e.string().optional(),
  archived: e.coerce.boolean().optional()
}), Tn = e.object({
  archived: e.coerce.boolean().optional()
}), On = e.object({
  pageSetId: t
}), jn = e.object({
  name: e.string().trim().optional(),
  productId: e.string().optional(),
  m3ProductId: e.string().optional(),
  themeId: e.string().optional(),
  funeralHomeId: e.string().optional(),
  homeTemplate: e.coerce.boolean().optional(),
  default: e.coerce.boolean().optional(),
  language: e.enum(a).optional()
}), ve = 'may hold only letters, digits, "_" and "-"', Re = e.object({
  itemId: e.string(),
  kind: e.enum(["tinymce", "lotus"]),
  pageIndex: e.number(),
  pageId: e.string().nullish(),
  settled: e.boolean(),
  frame: e.object({
    x: e.number(),
    y: e.number(),
    width: e.number(),
    height: e.number()
  }),
  fontSizesPt: e.array(e.number()).nullish(),
  scale: e.number().nullish(),
  lines: e.number().nullish(),
  loadHeight: e.number().nullish(),
  ceiling: e.number().nullish(),
  boundedBy: e.string().nullish(),
  overflowing: e.boolean().nullish(),
  /**
   * The room a flagged frame is past. The request loses its nulls on the way
   * (the API's denormalizer drops them), so a bound or a line height the
   * surface recorded as null arrives absent: both are read as nullish and
   * handed on as null, the shape the digest compares.
   */
  kept: e.object({
    ceiling: e.number(),
    boundedBy: e.string().nullish(),
    lineHeight: e.number().nullish()
  }).transform(({ ceiling: o, boundedBy: n, lineHeight: i }) => ({
    ceiling: o,
    boundedBy: n ?? null,
    lineHeight: i ?? null
  })).nullish(),
  sizing: e.string().nullish(),
  maxFontSizePt: e.number().nullish(),
  passes: e.number().nullish(),
  textHash: e.string().nullish(),
  stamps: e.record(
    e.string(),
    e.union([e.string(), e.number(), e.boolean(), e.null()])
  ).nullish()
}), Ue = e.object({
  surface: e.string(),
  takenAt: e.number().nullish(),
  boxes: e.array(Re)
}), Pn = e.object({
  html: e.string().trim(),
  pageHeight: e.coerce.number(),
  pageWidth: e.coerce.number(),
  orderId: e.string().trim(),
  productId: e.string().trim(),
  orderPageSetId: e.string().trim(),
  sendToWorker: e.boolean().optional(),
  frontendDomain: e.string().trim().optional(),
  /**
   * The server derives the job's funeral home from the order row and ignores
   * this field's value. The field is still required (an empty string passes),
   * and its pattern keeps a malformed value from passing the schema.
   */
  funeralHomeId: e.string().trim().regex(ie, ve),
  applicationType: r,
  /**
   * The requesting surface's text geometry, so the worker can hold its own
   * paint against it box by box. Optional: a request without one is
   * rendered as before and compared against nothing.
   */
  textGeometry: Ue.optional()
}), En = e.object({
  name: e.string().trim().optional()
}), Cn = e.object({
  productId: t,
  isM3: e.boolean().optional().default(!1)
}), Ne = 25, Fe = 25, Dn = 3, An = 15, Me = 2e3, _n = e.object({
  orderId: e.string().min(1),
  // 'MDL' orders share through the MDL flow; 'M3' orders (opened in the MDL
  // editor via an edit token) are forwarded to the M3 internal proof-share API.
  applicationType: r,
  orderProductIds: e.array(e.string()).min(1).max(Fe),
  recipientEmails: e.array(e.string().trim().pipe(e.email())).min(1).max(Ne),
  // Reply-To on the share email. Optional: the server falls back to the
  // sharing user's email when omitted.
  replyToEmail: e.string().trim().pipe(e.email()).optional(),
  // Optional free-text message from the director, rendered in the share email.
  comment: e.string().trim().max(Me).optional()
}), d = e.enum([
  "DEFAULT",
  "VISITATION_SERVICE",
  "VISITATION_ALL",
  "SERVICES",
  "ORDER_OF_SERVICE",
  "PALLBEARERS"
]), Ln = d.options, vn = e.object({
  productId: t,
  category: d.optional()
}), Rn = e.object({
  template: e.string().trim(),
  name: e.string().trim().nonempty(),
  productId: t,
  themeId: t.optional().nullable(),
  category: d.optional()
}), Un = e.object({
  template: e.string().trim().optional(),
  name: e.string().trim().nonempty().optional(),
  category: d.optional()
}), Nn = e.object({
  applicationType: r,
  layoutId: t.optional(),
  productId: t.optional(),
  themeId: t.optional(),
  archived: e.coerce.boolean().default(!1)
}), Fn = e.object({
  //customThemes: z.coerce.boolean().optional().default(false),
  archived: e.coerce.boolean().optional().default(!1)
}), Mn = e.object({
  name: e.string().trim(),
  description: e.string().trim().optional(),
  image: e.string().trim().optional(),
  font: e.string().trim().transform(ae).optional(),
  fontColorAccent1: e.string().trim().optional(),
  fontColorAccent2: e.string().trim().optional(),
  fontColor: e.string().trim().regex(/#\w+/, {
    error: "Invalid hex color"
  }).optional()
});
export {
  r as ApplicationTypeSchema,
  Be as EDITOR_TEXT_BOX_ITEM_TYPE,
  ve as FUNERAL_HOME_ID_SEGMENT_MESSAGE,
  je as LOTUS_TURNOVER_TRANSACTION_BUDGET,
  Me as MAX_PROOF_SHARE_COMMENT_LENGTH,
  Fe as MAX_PROOF_SHARE_PRODUCTS,
  Ne as MAX_PROOF_SHARE_RECIPIENTS,
  Dn as PROOF_SHARE_EXPIRATION_DAYS,
  An as PROOF_SHARE_HOLD_TIMEOUT_MINUTES,
  ke as REDIS_CHANNELS,
  me as RETURN_URL_MAX_LENGTH,
  Ln as SERVICE_TEMPLATE_CATEGORY_ORDER,
  b as UPSCALE_TARGET_EDGE_OUT_OF_RANGE_MESSAGE,
  ge as UPSCALE_TARGET_KIND_MESSAGE,
  Te as addCustomIssue,
  Io as addProductToBundleSchema,
  ko as applyOrderPageSetLayoutSchema,
  Tn as archiveOrderPageSchema,
  Ce as backgroundTypeSchema,
  gt as batchJobStatusInputSchema,
  Bt as bulkCreateCustomizationOptionsSchema,
  ln as cachePatternSchema,
  lt as caseCreateAdditionalData,
  de as caseCreateSchema,
  an as caseIdSchema,
  At as caseImageVariantAvailabilitySchema,
  he as caseImageVariantForCaseListItemSchema,
  z as caseImageVariantListItemSchema,
  Dt as caseImageVariantPricingSchema,
  Ot as caseImageVariantRefusedResponseSchema,
  Ct as caseImageVariantRevertedResponseSchema,
  Pt as caseImageVariantsForCaseResponseSchema,
  jt as caseImageVariantsForImageResponseSchema,
  _t as caseMemorialsSchema,
  it as casePreferencesSchema,
  j as casePreferencesUpdateSchema,
  rt as caseUpdateSchema,
  yt as checkAllFamilyImagesInUseInputSchema,
  St as checkFamilyImageInUseInputSchema,
  Qe as copyAllProductTemplatesSchema,
  $ as corporationCreateSchema,
  Xe as createAssetSubcategoriesSchema,
  Je as createAssetsSchema,
  Tt as createCaseImageVariantInputSchema,
  Lt as createCaseMemorialSchema,
  Mn as createCustomThemeSchema,
  vt as createCustomVerseSchema,
  We as createDefaultLayoutsForProductSchema,
  Rn as createGlobalServiceInformationTemplateSchema,
  Yo as createMetadataSchema,
  $e as createNewProductSchema,
  wo as createOrderPageDetailsSchema,
  Vo as createOrderPageSetSchema,
  xo as createOrderProductsSchema,
  zo as createOrderSchema,
  In as createPageSchema,
  bn as createPageSetSchema,
  hn as createPageSetSchemaV2,
  _n as createProofShareRequestSchema,
  Xo as createSessionSchema,
  Sn as createTemplateWithPagesSchema,
  ot as createVerseFormatSchema,
  E as customizationByIdSelectionSchema,
  eo as customizationCompareDetailsSchema,
  Ee as customizationCompareTypeSchema,
  Nt as customizationCreateSchema,
  H as customizationDisplayTypeSchema,
  Mt as customizationFiltersSchema,
  xt as customizationIdSchema,
  p as customizationOptionCreateSchema,
  zt as customizationOptionIdSchema,
  Ut as customizationOptionUpdateSchema,
  Pe as customizationQualitySchema,
  D as customizationTypeSchema,
  Ft as customizationUpdateSchema,
  C as customizationsByLabelSchema,
  ft as deleteAllFamilyImagesInputSchema,
  It as deleteFamilyImageInputSchema,
  ct as deleteImageInputSchema,
  Wo as deleteOrderPagesBulkSchema,
  Ht as designRequestQueueItemParamsSchema,
  Gt as designRequestQueueListQuerySchema,
  Zo as duplicateOrderSchema,
  Ze as duplicateThemeSchema,
  Z as editorBackButtonPayloadSchema,
  He as editorBackButtonRequestSchema,
  we as editorBackButtonResponseSchema,
  qo as ensureOrderPageSetsSchema,
  bt as familyPresignedUploadInputSchema,
  ht as familyProcessImageInputSchema,
  rn as funeralHomeIdSchema,
  Pn as generatePDFSchema,
  mn as getAllExpressionGuestsSchema,
  un as getAllFuneralHomeCasesQuerySchema,
  pn as getAllFuneralHomeCasesSchema,
  Ke as getAssetSubcategoriesSchema,
  re as getAssetsSchema,
  cn as getCaseProfileImagesSchema,
  sn as getCaseProfileSchema,
  at as getCasesSchema,
  Eo as getEditorOrderPageDetailsSchema,
  Co as getFuneralHomeOrdersSchema,
  vn as getGlobalServiceInformationTemplatesQuerySchema,
  ze as getMeResponseSchema,
  Ho as getOrderLayoutDetailsSchema,
  Ao as getOrderPageDetailSchema,
  Ro as getOrderProductsSchema,
  vo as getOrderSchema,
  Cn as getProductLayoutsSchema,
  tt as getVerseFormatSchema,
  Rt as getVersesQuerySchema,
  ue as isAllowedReturnUrl,
  qt as isZodError,
  qe as layoutTemplateCopySchema,
  kt as liminalTouchCaseInputSchema,
  Vt as liminalTouchFamilyContactInputSchema,
  nn as locationGuidSchema,
  Qt as lotusTurnoverBodySchema,
  Oe as lotusTurnoverPageSchema,
  $t as lotusTurnoverWorstCaseMs,
  Zt as m3CustomizationCreateSchema,
  Xt as m3CustomizationFiltersSchema,
  Yt as m3CustomizationIdSchema,
  A as m3CustomizationOptionCreateSchema,
  Jt as m3CustomizationOptionIdSchema,
  Wt as m3CustomizationOptionUpdateSchema,
  Kt as m3CustomizationUpdateSchema,
  io as m3ProductBulkCreateSchema,
  k as m3ProductCreateSchema,
  oo as m3ProductFiltersSchema,
  no as m3ProductIdSchema,
  po as m3ProductImageBulkCreateSchema,
  V as m3ProductImageCreateSchema,
  co as m3ProductImageFiltersSchema,
  mo as m3ProductImageIdSchema,
  so as m3ProductImageUpdateSchema,
  ao as m3ProductItmRefSchema,
  to as m3ProductUpdateSchema,
  Ae as m3ProductVariationCreateSchema,
  lo as m3ProductVariationIdSchema,
  De as m3ProductVariationSelectionInputSchema,
  ro as m3ProductVariationUpdateSchema,
  B as mdlCustomizationDisplayTypeSchema,
  P as mdlCustomizationTypeSchema,
  Ge as mdlEditorEventSchema,
  G as mdlThemeModeSchema,
  Ve as migrateDataSchema,
  pt as moveToFrontInputSchema,
  M as nameArrangementSchema,
  Go as orderLayoutDetailsSchema,
  Do as orderPageDetailSchema,
  _o as orderPageDetailSchemaV2,
  Fo as orderPageSetSchema,
  Mo as orderPageUpdateSchema,
  u as orderProductNicknameSchema,
  Uo as orderProductsSchemaV2,
  No as orderProductsUpdateSchema,
  Lo as orderSchema,
  dn as pageSetSchema,
  gn as pageSetSchemaV2,
  On as pagesSchema,
  ut as presignedUploadBatchInputSchema,
  st as presignedUploadInputSchema,
  dt as processBatchInputSchema,
  mt as processImageInputSchema,
  uo as productBundleCreateSchema,
  bo as productBundleFiltersSchema,
  ho as productBundleIdSchema,
  q as productBundleItemSchema,
  go as productBundleUpdateSchema,
  Po as productCategoryBulkCreateSchema,
  _e as productCategoryCreateSchema,
  To as productCategoryFiltersSchema,
  Oo as productCategoryIdSchema,
  jo as productCategoryToggleAvailabilitySchema,
  yo as productCategoryUpdateSchema,
  Q as productWithThemeAndCustomizationsSchema,
  Le as productWithThemeSchema,
  En as productsSchema,
  fo as removeProductFromBundleSchema,
  fn as replaceTemplatePagesSchema,
  $o as resetOrderProductSchema,
  x as returnUrlSchema,
  t as rowIdSchema,
  s as rowIdSchemaWithMessage,
  d as serviceTemplateCategorySchema,
  Et as setCaseImageVariantRevertedInputSchema,
  en as singleOrderProductCreateSchema,
  tn as singleOrderProductUpdateSchema,
  W as templatePageBodySchema,
  Re as textGeometryDigestBoxSchema,
  Ue as textGeometryDigestSchema,
  w as themeModeSchema,
  Nn as themeOverridesSchema,
  Fn as themesSchema,
  Ye as updateAssetSubcategoriesSchema,
  et as updateAssetsSchema,
  So as updateBundleItemQuantitySchema,
  Un as updateGlobalServiceInformationTemplateSchema,
  Jo as updateMessengerOrderSchema,
  Qo as updateOrderPageSetSchema,
  Bo as updateOrderSchema,
  yn as updatePageSchema,
  jn as updatePageSetSchemaV2,
  on as updateUserActAsAdminSchema,
  nt as updateVerseFormatSchema,
  be as upscaleTargetSizeSchema,
  Ko as validateOrderLanguageSchema,
  wt as watermarksSchema
};
